import React, { useEffect, useState } from "react";
import axios from "axios";
import { debounce } from "lodash";
import EditItemModal from "../modals/EditItemModal";
import { format, eachDayOfInterval, parseISO, isSameDay, addDays } from "date-fns";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import Modal from "./Modal";
import BookHotelsModal from "./BookHotelsModal";

const LodgingModal = ({ isOpen, onClose, onSave, subTripId, parentTripId }) => {
  const [lodgingItems, setLodgingItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [showDateRange, setShowDateRange] = useState(false);
  const [range, setRange] = useState([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
  const [place, setPlace] = useState("");
  const [details, setDetails] = useState("");
  const [cost, setCost] = useState("");
  const [url, setUrl] = useState("");
  const [setShowCreateSubTrip] = useState(false);
  const [setMissingDate] = useState(null);
  const [isAdding, setIsAdding] = useState(false);
  const [placeSuggestions, setPlaceSuggestions] = useState([]);
  const [placeQuery, setPlaceQuery] = useState("");
  const [showBookHotels, setShowBookHotels] = useState(false);
  const [bookHotelsParams, setBookHotelsParams] = useState({});  

	const [cityInput, setCityInput] = useState("");
	const [adults, setAdults] = useState(2);
	const [children, setChildren] = useState(0);
	const [rooms, setRooms] = useState(1);

	const handleSearchHotels = async () => {
	  try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/lodging/cities`, {
		  params: { query: cityInput },
		  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
		});

		if (!res.data || res.data.length === 0) {
		  alert("City not found on Booking.com");
		  return;
		}

		const dest_id = res.data[0].dest_id;

		setShowBookHotels(true);
		setBookHotelsParams({
		  dest_id,
		  startDate: format(range[0].startDate, "yyyy-MM-dd"),
		  endDate: format(range[0].endDate, "yyyy-MM-dd"),
		  rooms,
		  adults,
		  children
		});
		  // console.log("Passing to BookHotelsModal:", {
			  // dest_id,
			  // startDate: format(range[0].startDate, "yyyy-MM-dd"),
			  // endDate: format(range[0].endDate, "yyyy-MM-dd"),
			  // rooms,
			  // adults,
			  // children
		  // });		
	  } catch (err) {
		console.error(err);
		alert("Failed to search city");
	  }
	};

  useEffect(() => {
    if (isOpen && subTripId) {
      loadLodgingItems();
	  loadTripDates(); 
    }
  }, [isOpen, subTripId]);

	// 群組連續且相同 place 的住宿項目
	const groupLodgingItems = (items) => {
	  if (!items.length) return [];

	  // 按日期排序
	  const sorted = [...items].sort((a, b) => new Date(a.date) - new Date(b.date));

	  const groups = [];
	  let currentGroup = [sorted[0]];

	  for (let i = 1; i < sorted.length; i++) {
		const prev = currentGroup[currentGroup.length - 1];
		const curr = sorted[i];

		const prevDate = parseISO(prev.date);
		const currDate = parseISO(curr.date);
		const expectedNextDate = addDays(prevDate, 1);

		const isSameHotel = prev.place === curr.place;

		if (isSameHotel && isSameDay(currDate, expectedNextDate)) {
		  currentGroup.push(curr);
		} else {
		  groups.push(currentGroup);
		  currentGroup = [curr];
		}
	  }

	  if (currentGroup.length) {
		groups.push(currentGroup);
	  }

	  return groups;
	};

	const fetchPlaceSuggestions = debounce(async (query) => {
	  if (!query) return;

	  try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips/google_places`, {
		  params: { query },
		  headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		  },
		});
		setPlaceSuggestions(res.data);
	  } catch (err) {
		console.error("Failed to fetch place suggestions", err);
	  }
	}, 300);

	const handlePlaceInputChange = (e) => {
	  const val = e.target.value;
	  setPlaceQuery(val);
	  setPlace(val); // 原本的 place state
	  fetchPlaceSuggestions(val);
	};

	const handleSelectPlace = (suggestion) => {
	  setPlace(suggestion.name);
	  setDetails(suggestion.formatted_address);
	  setPlaceSuggestions([]); // 清空建議清單
	};

  const [tripStartDate, setTripStartDate] = useState(null);
  const [tripEndDate, setTripEndDate] = useState(null);
  
	const loadTripDates = async () => {
	  try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/trips/trips/${parentTripId}`, {
		  headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		  },
		});
		const { start_date, end_date } = res.data;
		setTripStartDate(new Date(start_date));
		setTripEndDate(new Date(end_date));
	  } catch (error) {
		console.error("Failed to load trip dates", error);
	  }
	};  

	useEffect(() => {
	  if (isOpen && parentTripId) {
		loadLodgingItems();
	  }
	}, [isOpen, parentTripId]);

	const [groupedLodgings, setGroupedLodgings] = useState([]);

	const loadLodgingItems = async () => {
	  try {
		const res = await axios.get(`${process.env.REACT_APP_API_URL}/subtripitems/trip/${parentTripId}/lodging_items`, {
		  headers: {
			Authorization: `Bearer ${localStorage.getItem("token")}`,
		  },
		});
		const grouped = groupLodgingItems(res.data);
		setGroupedLodgings(grouped);
		setLodgingItems(res.data); // 若你還需要原始資料
	  } catch (error) {
		console.error("Failed to load lodging items", error);
	  }
	};


  // 開啟編輯
  const handleEditClick = (item) => {
    setEditingItem(item);
    setEditedData({ ...item });
  };

  // 更新表單欄位
  const handleFieldChange = (field, value) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // 儲存修改
  const handleSaveEdit = async () => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/item/${editingItem.id}`,
        editedData
      );
      setEditingItem(null);
      loadLodgingItems();
	  setPlace("");
	  setDetails("");
	  setCost("");
	  setUrl("");
    } catch (error) {
      console.error("Failed to update item", error);
    }
  };

  const handleCancelEdit = () => {
    setEditingItem(null);
    setEditedData({});
  };

	const handleAddLodging = async () => {
	  setIsAdding(true);

	  const { startDate, endDate } = range[0];
	  if (!place || !startDate || !endDate) {
		alert("Please enter a location and date range");
		setIsAdding(false);
		return;
	  }

	  const days = eachDayOfInterval({ start: startDate, end: endDate });

	  try {
		for (let i = 0; i < days.length; i++) {
		  const currentDate = days[i];
		  const formattedDate = format(currentDate, "yyyy-MM-dd");

		  // 設定時間區間
		  let startTime = null;
		  let endTime = null;

		  if (i === 0) {
			// 第一晚
			startTime = "15:00";
			endTime = "23:59";
		  } else if (i === days.length - 1) {
			// 最後一晚
			startTime = "00:01";
			endTime = "10:00";
		  } else {
			// 中間日
			startTime = "00:01";
			endTime = "23:59";
		  }

		  // 取得該日對應的 subTripId
		  const res = await axios.get(`${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/date/${parentTripId}?date=${formattedDate}`, {
			headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
		  });

		  const matchedSubTripId = res.data.id;

		  // 送出 subTripItem
		  await axios.post(`${process.env.REACT_APP_API_URL}/subtripitems/sub_trip/${matchedSubTripId}/item`, {
			date: formattedDate,
			place,
			type: "lodging",
			details,
			start_time: startTime,
			end_time: endTime,
			cost,
			url,
		  }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
		  });
		}

		// 清空表單 & 重新載入
		setPlace("");
		setDetails("");
		setCost("");
		setUrl("");
		loadLodgingItems();
		onClose();
	  } catch (err) {
		console.error("新增失敗", err);
		alert("新增失敗，請稍後再試");
	  } finally {
		setIsAdding(false);
	  }
	};
  
  if (!isOpen) return null;

  return (
  <Modal isOpen={isOpen} onClose={onClose}>
    <div className="modal-content responsive-container w-full max-w-2xl max-h-[90vh] overflow-y-auto">
      <h2 className="heading mb-4 text-primary">Lodging Details</h2>
        <ul className="space-y-3 mb-6">
			{groupedLodgings.map((group, idx) => {
			  const first = group[0];
			  const last = group[group.length - 1];
			  return (
				<li
				  key={idx}
				  className="border border-accent p-4 rounded-md cursor-pointer hover:bg-yellow-50"
				  onClick={() => handleEditClick(first)} // 點擊仍編輯第一筆
				>
				  <div className="font-semibold text-lg">{first.place}</div>
				  <div className="text-sm text-gray-500">
					{format(new Date(first.date), "EEE, MMM d")} - {format(new Date(last.date), "EEE, MMM d")}
				  </div>
				  <div className="text-sm">{first.details}</div>
				  {first.cost && (
					<div className="text-sm text-gray-600">Cost: ${first.cost}</div>
				  )}
				  {first.url && (
					<a
					  href={first.url}
					  className="text-blue-500 text-sm underline"
					  target="_blank"
					  rel="noopener noreferrer"
					  onClick={(e) => e.stopPropagation()}
					>
					  More Info
					</a>
				  )}
				</li>
			  );
			})}
        </ul>

        {/* ➕ Add Lodging Section */}
        <div className="border-t border-gray-300 pt-4 mb-4">
          <h3 className="text-md font-semibold text-secondary mb-2">Add Booked Lodging</h3>
			<div className="relative w-full">
			  <input
				type="text"
				placeholder="Place"
				value={placeQuery}
				onChange={handlePlaceInputChange}
				className="form-input"
			  />
			  <p className="text-sm text-gray-500 mt-1 ml-1">
			    Please enter the full place name(e.g.,“XYZ Hotel”)
			  </p>				  
			  {placeSuggestions.length > 0 && (
				<ul className="absolute bg-white border border-gray-300 mt-1 rounded shadow z-50 w-full max-h-48 overflow-y-auto">
				  {placeSuggestions.map((sug) => (
					<li
					  key={sug.place_id}
					  onClick={() => handleSelectPlace(sug)}
					  className="p-2 hover:bg-yellow-100 cursor-pointer"
					>
					  <div className="font-medium">{sug.name}</div>
					  <div className="text-sm text-gray-500">{sug.formatted_address}</div>
					</li>
				  ))}
				</ul>
			  )}
			</div>
          <div className="flex flex-col md:flex-row gap-2 mb-2">
            <input
              type="text"
              placeholder="Estimated cost"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              className="form-input"
            />
            <input
              type="text"
              placeholder="URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="form-input"
            />
          </div>
          <div className="mb-3">
            <button
              onClick={() => setShowDateRange(!showDateRange)}
              className="bg-gray-100 px-3 py-2 rounded hover:bg-gray-200 btn-full"
            >
              {format(range[0].startDate, "yyyy-MM-dd")} ~ {format(range[0].endDate, "yyyy-MM-dd")}
            </button>
            {showDateRange && (
			  <div className="overflow-x-auto max-w-full">
				<DateRange
				  editableDateInputs={true}
				  onChange={(item) => setRange([item.selection])}
				  moveRangeOnFirstSelection={false}
				  ranges={range}
				  minDate={tripStartDate || undefined}
				  maxDate={tripEndDate || undefined}
				/>
			  </div>
            )}
          </div>
          <button
            onClick={handleAddLodging}
			disabled={isAdding}
            className="bg-accent text-white px-4 py-2 rounded hover:bg-yellow-600 btn-full mb-4"
          >
            + Add Booked Hotel
          </button>
        </div>
		
		<div className="border-t border-gray-300 pt-4 mb-4">
		  <h3 className="text-md font-semibold text-secondary mb-2">Search Hotels (Booking.com)</h3>
		  
		  <input
			type="text"
			placeholder="City"
			value={cityInput}
			onChange={(e) => setCityInput(e.target.value)}
			className="form-input mb-2"
		  />

		  <div className="mb-3">
			<button
			  onClick={() => setShowDateRange(!showDateRange)}
			  className="bg-gray-100 px-3 py-2 rounded hover:bg-gray-200 btn-full"
			>
			  {format(range[0].startDate, "yyyy-MM-dd")} ~ {format(range[0].endDate, "yyyy-MM-dd")}
			</button>
			{showDateRange && (
			  <DateRange
				editableDateInputs={true}
				onChange={(item) => setRange([item.selection])}
				moveRangeOnFirstSelection={false}
				ranges={range}
				minDate={tripStartDate || undefined}
				maxDate={tripEndDate || undefined}
			  />
			)}
		  </div>

		  <div className="grid grid-cols-3 gap-2 mb-3">
			<input type="number" min="1" value={adults} onChange={(e)=>setAdults(+e.target.value)} className="form-input" placeholder="Adults" />
			<input type="number" min="0" value={children} onChange={(e)=>setChildren(+e.target.value)} className="form-input" placeholder="Children" />
			<input type="number" min="1" value={rooms} onChange={(e)=>setRooms(+e.target.value)} className="form-input" placeholder="Rooms" />
		  </div>

		  <button
			onClick={handleSearchHotels}
			className="bg-blue-500 text-white px-4 py-2 rounded mb-3 w-full"
		  >
			Search Hotels
		  </button>
		</div>

		<BookHotelsModal
		  isOpen={showBookHotels}
		  onClose={() => setShowBookHotels(false)}
		  {...bookHotelsParams}
		/>

        <div className="text-right pt-4">
          <button
            className="bg-accent text-white px-4 py-2 rounded hover:bg-yellow-600 btn-full"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
	  
      {editingItem && (
        <EditItemModal
          isOpen={!!editingItem}
          itemData={editedData}
          onChange={handleFieldChange}
          onClose={handleCancelEdit}
          onSave={handleSaveEdit}
        />
      )}	  
    </Modal>
  );
};

export default LodgingModal;
